'use client';

import { useEffect } from 'react';

export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.register('/sw.js')
      .then(registration => registration.update().catch(() => undefined))
      .catch(() => undefined);
  }, []);

  return null;
}
